// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Lingui from "../../locales/Lingui.re.mjs";
import * as DefaultLayoutContentPage from "../pages/DefaultLayoutContentPage.re.mjs";

import { css, cx } from '@linaria/core'
;

import { t } from '@lingui/macro'
;

var loadMessages = Lingui.loadMessages({
      ja: import("../../locales/src/components/pages/DefaultLayoutContentPage.re/ja"),
      en: import("../../locales/src/components/pages/DefaultLayoutContentPage.re/en")
    });

var Component = DefaultLayoutContentPage.make;

export {
  Component ,
  loadMessages ,
}
/*  Not a pure module */
